import React from "react";
import moment from "moment-timezone";
import { Selector } from "./Selector";
import { Button, Typography } from "@material-ui/core";
import { store } from "../globalState/StateProvider";

export interface WorkerListDownloadDisplayProps {
	//The subscriptionId used for the environment list load
	subscriptionId: string;

	//The productId used for the environment list load
	productId: string;

	//The name of the company used as part of the suggested filename for the download
	companyName: string;
}

export const WorkerListDownload = (props: WorkerListDownloadDisplayProps) => {
	const { environments, subscription, getEnvironmentByValue } = React.useContext(store);

	const [selectedEnvironment, setSelectedEnvironment] = React.useState(
		subscription && subscription.subscription!.subscriptionId === props.subscriptionId && environments.length > 0
			? environments[0].valueString!
			: "",
	);

	const createDownloadFilename = () => {
		const envName =
			environments.length > 0
				? selectedEnvironment !== ""
					? getEnvironmentByValue!(selectedEnvironment)?.displayString
					: environments[0].displayString
				: "";
		const fileDate = moment().format("YYYYMMDDHHmmss");
		return `${props.companyName}_${envName}_${fileDate}.csv`;
	};

	return (
		<div>
			<div style={{ margin: "36px 0 12px 0" }}>
				<Typography variant="h6">Worker List Download</Typography>
			</div>
			<div style={{ display: "flex", alignItems: "center" }}>
				<Selector
					initialValue={
						environments.length > 0
							? selectedEnvironment !== ""
								? selectedEnvironment
								: environments[0].valueString!
							: "None"
					}
					label="Environments"
					items={
						environments.length > 0
							? environments
							: [
									{
										displayString: "None",
										valueString: "None",
									},
								]
					}
					updateSelected={setSelectedEnvironment}
				/>
				{(selectedEnvironment !== "" || environments.length > 0) && (
					<Button
						href={`/api/v1/${props.productId}/twilio/workers/${
							props.subscriptionId
						}/${selectedEnvironment}/getWorkersForAccountAsCsv?fileName=${createDownloadFilename()}`}
					>
						Download
					</Button>
				)}
			</div>
		</div>
	);
};
